import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IApplicableMembershipBenefits) {
    (function(ApplicableMembershipBenefitType) {
        ApplicableMembershipBenefitType["APPLICABLE_MEMBERSHIP_BENEFIT_TYPE_UNKNOWN"] = "APPLICABLE_MEMBERSHIP_BENEFIT_TYPE_UNKNOWN";
        ApplicableMembershipBenefitType["INSIDER_FREE_SHIPPING"] = "INSIDER_FREE_SHIPPING";
        ApplicableMembershipBenefitType["INSIDER_FREE_DUTIES"] = "INSIDER_FREE_DUTIES";
        ApplicableMembershipBenefitType["INSIDER_DISCOUNT_BPS"] = "INSIDER_DISCOUNT_BPS";
        ApplicableMembershipBenefitType["INSIDER_FREE_SHIPPING_WITH_THRESHOLD"] = "INSIDER_FREE_SHIPPING_WITH_THRESHOLD";
        ApplicableMembershipBenefitType["INSIDER_FREE_DUTIES_WITH_THRESHOLD"] = "INSIDER_FREE_DUTIES_WITH_THRESHOLD";
        ApplicableMembershipBenefitType["INSIDER_OPENING_ORDER_DISCOUNT"] = "INSIDER_OPENING_ORDER_DISCOUNT";
    })(IApplicableMembershipBenefits.ApplicableMembershipBenefitType || (IApplicableMembershipBenefits.ApplicableMembershipBenefitType = {}));
    IApplicableMembershipBenefits.build = function(partial) {
        return _object_spread({
            benefits: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IApplicableMembershipBenefits || (IApplicableMembershipBenefits = {}));
export var IApplicableMembershipBenefits;
